import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Security|Violations|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSecurityViolations';
export type SPCandidateSecurityViolationsLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelDate`
	| `${LocNameStart}LabelViolation`
	| `${LocNameStart}LabelSubtype`
	| `${LocNameStart}LabelDetails`
	| `${LocNameStart}LabelExam`;

export const spCandidateSecurityViolationsLocs: LocDefs<SPCandidateSecurityViolationsLocNames> = {
	SPCandidateSecurityViolationsTitleTab: {
		defaultValue: 'Exam Violations',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidatesSecurity.ExamViolations.Title.TabTitle',
		...sharedProperties,
	},
	SPCandidateSecurityViolationsTitlePage: {
		defaultValue: 'Exam Violations',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidatesSecurity.ExamViolations.Title.PageTitle',
		...sharedProperties,
	},
	SPCandidateSecurityViolationsLabelDate: {
		defaultValue: 'Date',
		description: 'Column heading for: Date.',
		displayPath: `${pathStart}Date`,
		displayType: 'Label',
		legacyName: 'Exam/CandidatesSecurity.ExamViolations.ColumnHeading.Created',
		...sharedProperties,
	},
	SPCandidateSecurityViolationsLabelViolation: {
		defaultValue: 'Violation',
		description: 'Column heading for: Violation.',
		displayPath: `${pathStart}Violation`,
		displayType: 'Label',
		legacyName: 'Exam/CandidatesSecurity.ExamViolations.ColumnHeading.Type',
		...sharedProperties,
	},
	SPCandidateSecurityViolationsLabelSubtype: {
		defaultValue: 'Subtype',
		description: 'Column heading for: Subtype.',
		displayPath: `${pathStart}Subtype`,
		displayType: 'Label',
		legacyName: 'Exam/CandidatesSecurity.ExamViolations.ColumnHeading.Subtype',
		...sharedProperties,
	},
	SPCandidateSecurityViolationsLabelDetails: {
		defaultValue: 'Details',
		description: 'Column heading for: Details.',
		displayPath: `${pathStart}Details`,
		displayType: 'Label',
		legacyName: 'Exam/CandidatesSecurity.ExamViolations.ColumnHeading.Details',
		...sharedProperties,
	},
	SPCandidateSecurityViolationsLabelExam: {
		defaultValue: 'Exam',
		description: 'Column heading for: Exam.',
		displayPath: `${pathStart}Exam`,
		displayType: 'Label',
		legacyName: 'Exam/CandidatesSecurity.ExamViolations.ColumnHeading.Exam',
		...sharedProperties,
	},
};

export type SPCandidateSecurityViolationsLocType = LocMap<SPCandidateSecurityViolationsLocNames>;
